import { t as uiText } from '../../i18n';
import { signOut } from 'firebase/auth';
import { auth } from '../../lib/firebase';
import { useNavigate } from 'react-router-dom';

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      // Firebase認証からログアウト（embedモードではauthがnullの場合がある）
      if (auth) {
        await signOut(auth);
      }

      // ブラウザのローカルストレージとセッションストレージをクリア
      localStorage.clear();
      sessionStorage.clear();

      // ページをリロードして完全に状態をリセット
      window.location.href = '/sys/login';
    } catch (error) {
      console.error('ログアウト失敗:', error);
      alert(uiText("Failed to log out"));
    }
  };

  return logout;
};